module.exports = __webpack_public_path__ + "static/img/TO.baad858f.svg";